import * as explosivesPermitReducer from "../reducers/explosivesPermitReducer";

// eslint-disable-next-line import/prefer-default-export
export const { getExplosivesPermits } = explosivesPermitReducer;
